import { toast } from 'react-toastify';
import { UseMutationResult, UseQueryResult } from '@tanstack/react-query';
import { Form } from '@ui';
import {
  getDefaultSSchedulerInputsValues,
  sSchedulerSettingsInputsFormSchema,
} from '@lp/features/Scheduler/SchedulerSurgeonsSettings/config';
import { SchedulerSettingsSubmitRow } from '@lp/features/Scheduler/components';
import { SSchedulerSettingsInputsFormType } from '@lp/features/Scheduler/SchedulerSurgeonsSettings/types';
import { SSchedulerSettingsInputsForm } from '@lp/features/Scheduler/SchedulerSurgeonsSettings/components';
import { omitKidneyOrganRules } from '@lp/features/Scheduler/utils';
import { SRegion, SRequirementsInputsSettings } from '@/api/apis/resources/schedule';
import { retrieveUnifiedError } from '@/api/utils';

type SSchedulerSettingsInputsTabProps = {
  scheduleBackPath: string;
  useSScheduleRegionsQuery: () => UseQueryResult<SRegion[]>;
  useSScheduleSettingsInputsQuery: () => UseQueryResult<SRequirementsInputsSettings, Error>;
  useSSetScheduleSettingsInputsMutation: () => UseMutationResult<
    SRequirementsInputsSettings,
    Error,
    SRequirementsInputsSettings
  >;
};

export const SSchedulerSettingsInputsTab = ({
  scheduleBackPath,
  useSScheduleRegionsQuery,
  useSScheduleSettingsInputsQuery,
  useSSetScheduleSettingsInputsMutation,
}: SSchedulerSettingsInputsTabProps) => {
  const { data: regionList } = useSScheduleRegionsQuery();
  const { data: inputsData } = useSScheduleSettingsInputsQuery();
  const { mutateAsync, isPending } = useSSetScheduleSettingsInputsMutation();

  const handleSubmit = async (data: SSchedulerSettingsInputsFormType) => {
    try {
      await mutateAsync({
        ...data,
        perRegions: omitKidneyOrganRules(data.perRegions),
      });
      toast.success(`Scheduler Inputs updated successfully`);
    } catch (e) {
      const error = retrieveUnifiedError(e);
      toast.error(error.message);
    }
  };

  if (!regionList || !inputsData) return null;

  return (
    <Form<SSchedulerSettingsInputsFormType>
      defaultValues={getDefaultSSchedulerInputsValues(inputsData)}
      // TMDXLP-14091
      // TODO: Remove after Kidney support
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      schema={sSchedulerSettingsInputsFormSchema}
      onSubmit={handleSubmit}
    >
      <SSchedulerSettingsInputsForm regionList={regionList} />
      <SchedulerSettingsSubmitRow backPath={scheduleBackPath} isLoading={isPending} />
    </Form>
  );
};
